export const defaultImgName = { name: 'заставка.jpg', type: 'image/jpeg', size: 0 }
